<template>
  <HeadBannerFrame
    v-if="blockData.image"
    :is-header="isHeader"
    :has-bar="!!area.id"
  >
    <template #background>
      <ImageBasic
        :image-data="blockData.image"
        classes="h-full object-cover object-center"
      ></ImageBasic>
    </template>
    <template v-if="area.id" #card>
      <div class="relative h-full">
        <h3 class="font-josefin md:text-2xl">{{ area.title }}</h3>
        <div class="absolute bottom-0 text-white opacity-20">
          <FaIcon
            :icon-class="'fas fa-' + area.icon?.label"
            classes="text-4xl md:text-6xl"
          />
        </div>
      </div>
    </template>
    <template #watermark>
      <div
        v-if="blockData.image?.desktop?.copyright"
        class="max-w-[180px] absolute bottom-[45px] md:bottom-[60px] right-[15px] md:right-[30px] text-right z-20"
      >
        <span
          class="text-sm italic font-light text-white drop-shadow-xs font-roboto leading-xs"
          >&copy; {{ blockData.image.desktop.copyright }}</span
        >
      </div>
    </template>
  </HeadBannerFrame>
</template>

<script lang="ts" setup>
import { useAreaStore } from '@/stores/useArea';
import ImageBasic from '@/components/components/core/basicImage/image-basic.vue';
import type { AreaIntroTopBannerData } from '../blockType';
import FaIcon from '@/components/fa-icon.vue';
import HeadBannerFrame from '@/components/components/headBannerFrame/headBannerFrame.vue';

defineProps({
  blockData: {
    type: Object as PropType<AreaIntroTopBannerData>,
    required: true,
    default: {} as AreaIntroTopBannerData,
  },
  isHeader: {
    type: Boolean,
    required: true,
    default: () => {
      return false;
    },
  },
});

const areaStore = useAreaStore();
const area = areaStore.getActiveArea;
</script>
